import React, { useContext } from 'react';
import {
  Button,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import CommentsContext from '../../hooks/CommentsContext';
import { Comment } from '../../types';
import { getCommentsDate } from '../../utilities';

const useStyles = makeStyles((theme: Theme) => createStyles({
  buttonText: {
    fontSize: '14px',
    width: '40px',
  },
  commentCard: {
    color: '#999',
    borderBottom: '1px solid #eee',
    margin: '0 10px',
    padding: '0 10px',
    '& h4, h5': {
      margin: '8px 0',
    },
    '& p': {
      color: '#000',
    },
  },
  undoButton: {
    marginBottom: 10,
    borderColor: '#003F2D',
    '& .MuiButton-label': {
      textTransform: 'none',
      color: '#003F2D',
      width: '60px',
    },
    '&.MuiButtonBase-root:hover': {
      boxShadow: 'none',
    },
  },
  undoRoot: {
    display: 'block',
    textAlign: 'right',
    marginTop: '6px',
  },
}));

type Props = {
  comm: Comment;
  editSurveyComments: (propId?: string, newComment?: string) => void;
};

// eslint-disable-next-line import/prefer-default-export
export const CommCard: React.FC<Props> = ({ comm, editSurveyComments }) => {
  const classes = useStyles();

  return (
    <div className={classes.commentCard}>
      <h4>{comm?.userName}</h4>
      <p>{comm?.comment}</p>
      { comm?.isNew ? '' : getCommentsDate(comm.createdOn) }
      { comm?.isNew ? <UndoCommentBtn comm={comm} editSurveyComments={editSurveyComments} /> : null }
    </div>
  );
};

const UndoCommentBtn: React.FC<Props> = ({ comm, editSurveyComments }) => {
  const [cancelable, setCancelable] = React.useState(true);
  const { setCommPanelFormEnabled, setCommentPending, timeLeft, setTimeLeft } = useContext(CommentsContext);
  const classes = useStyles();

  const clearComment = () => {
    setCancelable(false);
    editSurveyComments();
    setCommPanelFormEnabled(true);
    setCommentPending(false);
    setTimeLeft(5);
  };

  return (
    cancelable
      ? (
        <div className={classes.undoRoot}>
        <Button
          size="small"
          variant="outlined"
          className={classes.undoButton}
          onClick={clearComment}
        >
          <Typography
            className={classes.buttonText}
            style={{ color: '#003F2D' }}
          >
            Undo:
          </Typography>
          <Typography
            className={classes.buttonText}
            style={{ color: '#003F2D' }}
          >
            {timeLeft}
          </Typography>
        </Button>
      </div>
      )
      : null
  );
};
